export * from './menu-rigth.component';
